<template>
  <div class="partLesson" v-if="data">
    <!-- part清單 -->
    <div class="list container mx-auto" v-if="sectionList === 1">
      <div v-for="(item, index) in data" :key="index" class="border-b py-3">
        <a href="#" @click.prevent="goToSection(index + 1)"
          class="text-decoration-none block"
        >
          <h5 class="m-0 flex justify-center items-center text-xl">
            <span>{{ item.name }}</span>
            <img class="fa-caret-right" src="~@/assets/icon/caret-right-solid.svg">
          </h5>
        </a>
      </div>
    </div>

    <!-- part課程清單 -->
    <div class="partDetail container mx-auto" v-if="sectionList === 2">
      <h5 class="border-b mx-auto py-3 text-xl flex justify-center">
        <span>{{ data[section - 1].name }}</span>
        <img class="fa-caret-right opacity-0" src="~@/assets/icon/caret-right-solid.svg">
      </h5>
      <div class="border-0 py-3 btn-classes">
        <div class="partLesson_content">
          <div class="flex justify-center text-center flex-wrap">
            <div
              class="pr-1 pl-1 pb-1 flex justify-center flex-col"
              v-for="(item, idx) in data[section - 1].parts" :key="idx"
            >
              <div class="class_text text-center">
                <p class="m-0"><span>{{ item.name }}</span></p>
              </div>
              <div class="class_btn">
                <a href="#" @click.prevent="goToPart(section, item.part)">
                  <div class="btn_voice mx-auto" v-if="item.file && item.file.indexOf('mp3') > -1">
                    <img src="~@/assets/btn/btn_voice.png" :alt="item.name" />
                  </div>
                  <div class="btn_voice mx-auto" v-else>
                    <img src="~@/assets/btn/btn_video.png" :alt="item.name" />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="mt-5 mb-2 mb-sm-5 w-full" @click="goBack(1)">
            <div class="closeBtn mx-auto">
              <img src="~@/assets/btn/btn_close_black.png" alt="Close" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 影片 -->
    <videoPlayer v-if="sectionList == 3"
      v-on:changeSection="changeSection"
      :path="path"
      :fileUrl="fileUrl"
      :fileType="fileType"
      :audioCover="audioCover"
      />
</div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import videoPlayer from '@/components/magazine/ToggleType'

export default {
  name: 'partLesson',
  components: {
    videoPlayer
  },

  props: {
    data: {
      type: Array,
      required: true
    },
    routeId: {
      type: String,
      required: true
    },
    selectRouteIdx: {
      type: Number,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    closeVideoJs: {
      type: Boolean,
      required: true
    },
    audioCover: {
      type: String,
      default: ''
    }
  },

  setup(props, { emit }) {
    const router = useRouter()
    const route = useRoute()
    const sectionList = ref(1)

    // 回傳 section / part
    const section = computed(() => Number(route.params.section || 1))
    const part = computed(() => Number(route.params.parts || 1))

    // 切換不同視圖狀態
    const changeSection = (num) => {
      sectionList.value = num
      emit('toggleAIBtn', num !== 3)
    }

    // 導航至 section
    const goToSection = (sectionNumber) => {
      changeSection(2)
      router.push({
        name: 'magazine',
        params: {
          id: props.routeId,
          section: sectionNumber
        }
      })
    }

    // 導航至 part
    const goToPart = (sectionNumber, partNumber) => {
      changeSection(3)
      router.push({
        name: 'magazine',
        params: {
          id: props.routeId,
          section: sectionNumber,
          parts: partNumber
        }
      })
    }

    // 回到上一層或列表
    const goBack = (level) => {
      changeSection(level)
      if (level === 1) {
        router.push({
          name: route.name,
          params: { id: props.routeId } // 不要帶 section/parts
        })
      } else if (level === 2) {
        router.push({
          name: route.name,
          params: {
            id: props.routeId,
            section: route.params.section
          }
        })
      }
    }

    const fileUrl = computed(() => {
      const partData = props.data[section.value - 1]?.parts[part.value - 1]
      if (partData?.youtubeUrl) return `https://www.youtube.com/embed/${partData.youtubeUrl}`
      if (partData?.file.includes('https')) return partData.file
      return encodeURIComponent(props.data[section.value - 1].name) + '/' + partData.file
    })

    const fileType = computed(() => {
      const partData = props.data[section.value - 1]?.parts[part.value - 1]
      if (partData?.youtubeUrl) return 'youtube'
      if (partData?.file.includes('mp4')) return 'video'
      return 'audio'
    })
    const updateSectionListByRoute = () => {
      if (props.closeVideoJs === true) {
        changeSection(1)
        emit('toggleAIBtn', true)
      }

      if (route.params.parts) {
        goToPart(route.params.parts)
        emit('toggleAIBtn', false)
      } else if (route.params.section) {
        goToSection(route.params.section)
        emit('toggleAIBtn', true)
      } else {
        changeSection(1)
        emit('toggleAIBtn', true)
      }
    }

    watch (
      () => props.data,
      (val) => {
        if (val && val.length) {
          updateSectionListByRoute()
        }
      },
      { immediate: true }
    )

    onMounted(() => {
      updateSectionListByRoute()
    })

    return {
      sectionList,
      section,
      part,
      fileUrl,
      fileType,
      changeSection,
      goToSection,
      goToPart,
      goBack
    }
  }
}
</script>

<style lang="scss" scoped>
  p, h5 {
  font-family: 'Arial', Times, serif, '微軟正黑體';
  color: #000;
  }
  span {
    white-space: pre-wrap;
  }
  .w-80 {
    width: 80%;
  }
  .opacity-0 {
    opacity: 0;
  }
  .fa-caret-right {
    width: 10px;
    height: 10px;
    margin-left: 8px;
  }
  .container {

    h5:hover {
      text-decoration:none;
    }
    a:hover {
      text-decoration:none;
    }
  }
  .partLesson {
    min-height: 360px;
    .btn-classes {
      max-width: 650px;
      width: 100%;
      margin: auto;
      .partLesson_content {
        .class_text {
          height:50px;
          width:96px;
          p {
            line-height: 50px;
            white-space: pre-wrap;
          }
        }
        .class_btn {
          .btn_voice {
            cursor: pointer;
            height: 80px;
            width: 80px;
              img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
        .closeBtn {
          height: 40px;
          width: 40px;
          border: 1px solid #000000;
          border-radius: 50%;
          padding: 4px;
          img {
            height: 100%;
            width: 100%;
            cursor: pointer;
            object-fit: contain;
          }
        }
      }
    }
  }
</style>
